<div
    *transloco="let t"
    [class]="'bazis-control bazis-number-buttons-control ' + cssClassSizeControl"
    [ngClass]="{
        'bazis-control--focused': isFocused,
        'bazis-control--dirty': ngControl.control.dirty,
        'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
        'bazis-control--invalid': ngControl.control.invalid,
        'bazis-control--disabled': field.disabled,
    }"
>
    <ng-container
        *ngIf="{
            required: required$ | async,
            valueChanges: valueChanges$ | async,
        } as data"
    >
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="data.required"
        >
            <bazis-interrogation
                *ngIf="tooltipKey"
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                [icon]="icons.interrogation"
                [type]="interrogationType"
            ></bazis-interrogation>
        </bazis-label>

        <div
            class="bazis-control__field-group"
            [class.bazis-control__field-group--disabled]="field.disabled"
            [class.bazis-control__field-group--focused]="isFocused"
        >
            <bazis-control-field-start
                [icon]="leftIcon"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipSettings]="tooltipSettings"
            >
            </bazis-control-field-start>
            <bazis-button
                *ngIf="increment && hasStepButton && !field.disabled"
                fill="outline"
                color="action"
                (click)="addToValue(-increment)"
                [disabled]="
                    minNumber !== undefined &&
                    minNumber !== null &&
                    (field.value || 0) - increment < minNumber
                "
            >
                <bazis-icon
                    color="action"
                    slot="icon-only"
                    [name]="icons.minus"
                ></bazis-icon>
            </bazis-button>
            <span class="bazis-number-buttons-control__data">
                {{ field.value || 0 }}
                <ng-container *ngIf="unitKey">
                    <span [innerHTML]="t(unitKey)"></span>
                </ng-container>
            </span>
            <bazis-button
                *ngIf="increment && hasStepButton && !field.disabled"
                fill="outline"
                color="action"
                (click)="addToValue(+increment)"
                [disabled]="
                    maxNumber !== undefined &&
                    maxNumber !== null &&
                    (field.value || 0) + increment > maxNumber
                "
            >
                <bazis-icon
                    color="action"
                    slot="icon-only"
                    [name]="icons.plus"
                ></bazis-icon>
            </bazis-button>

            <bazis-control-field-end
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipSettings]="tooltipSettings"
            >
            </bazis-control-field-end>
        </div>

        <div class="bazis-control__error">
            <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
        </div>

        <div
            *ngIf="noteKey"
            class="bazis-control__note"
        >
            {{ t(noteKey, noteParams) }}
        </div>
    </ng-container>
</div>
